// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import API from "../Context/api";
// import Spinner from "../Helpers/Spinner";
// import AddComputerForm from "../Inventory/AddComputerForm";
// import EditComputerForm from "../Inventory/EditComputerForm";
// import CloseComputerForm from "../Inventory/CloseComputerForm";

// function Inventory() {
//   const [computers, setComputers] = useState([]);
//   const [computerToDelete, setComputerToDelete] = useState(null);
//   const [computerToEdit, setComputerToEdit] = useState(null);
//   const [computerToClose, setComputerToClose] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalOpenEdit, setModalOpenEdit] = useState(false);
//   const [modalOpenClose, setModalOpenClose] = useState(false);

//   const navigate = useNavigate();

//   // const fetchComputers = async () => {
//   //   try {
//   //     const response = await API.get("/computers");
//   //     setComputers(response.data);
//   //     console.log("response.data................");
//   //     console.log(response.data);
//   //     setLoading(false);
//   //   } catch (error) {
//   //     setError("Failed to fetch computers");
//   //     setLoading(false);
//   //   }
//   // };

//   const generateDummyComputers = () => {
//     const makes = ["Dell", "HP", "Lenovo", "Apple", "Asus"];
//     const clients = ["Client A", "Client B", "Client C", "Client D"];
//     const statuses = ["Active", "Inactive", "In Repair", "Retired"];
//     const techs = ["John Doe", "Jane Smith", "Mike Brown", "Emily White"];

//     return Array.from({ length: 30 }, (_, i) => ({
//       name: `Computer-${i + 1}`,
//       serialNumber: `SN-${100000 + i}`,
//       inventoryId: `INV-${200000 + i}`,
//       make: makes[i % makes.length],
//       client: clients[i % clients.length],
//       companyTag: `TAG-${3000 + i}`,
//       status: statuses[i % statuses.length],
//       techAssigned: techs[i % techs.length],
//     }));
//   };

//   // Use this instead of API call for now
//   const fetchComputers = async () => {
//     try {
//       const dummyData = generateDummyComputers();
//       setComputers(dummyData);
//       console.log("Dummy data................");
//       console.log(dummyData);
//       setLoading(false);
//     } catch (error) {
//       setError("Failed to fetch computers");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchComputers();
//   }, []);

//   const handleDeleteClick = (computerId) => {
//     setComputerToDelete(computerId);
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setModalOpenEdit(false);
//     setModalOpenClose(false);
//     setComputerToDelete(null);
//     setComputerToEdit(null);
//     setComputerToClose(null);
//   };

//   const handleDeletePost = async () => {
//     if (computerToDelete) {
//       try {
//         await API.delete(`/computers/${computerToDelete}`);
//         setComputers(
//           computers.filter(
//             (computer) => computer.computerId !== computerToDelete
//           )
//         );
//       } catch (error) {
//         alert("Failed to delete computer.");
//       } finally {
//         closeModal();
//       }
//     }
//   };

//   const handleEditPost = (computerId) => {
//     setComputerToEdit(computerId);
//     setModalOpenEdit(true);
//   };

//   const handleCloseComputer = (computerId) => {
//     setComputerToClose(computerId);
//     setModalOpenClose(true);
//   };

//   const handleViewReport = (computerId) => {
//     navigate(`/report/${computerId}`);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const filteredComputers = computers.filter(
//     (computer) =>
//       (computer.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (computer.serialNumber || "")
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase())
//   );

//   const handleAddComputer = () => {
//     setIsModalOpen(true);
//   };

//   const handleComputerUpdated = () => {
//     fetchComputers();
//     closeModal();
//   };

//   if (error) return <div className="text-red-500">{error}</div>;

//   return (
//     <div className="w-full relative">
//       {loading && <Spinner />}
//       <div className="flex flex-col md:flex-row justify-between items-center p-4 md:py-4 gap-4 md:gap-0">
//         <input
//           type="text"
//           placeholder="Search by name or serial number..."
//           value={searchQuery}
//           onChange={handleSearchChange}
//           className="p-2 border rounded w-full md:w-64 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//         />
//         <button
//           onClick={handleAddComputer}
//           className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full md:w-auto"
//         >
//           Add Computer
//         </button>
//       </div>
//       <div className="hidden md:block overflow-x-auto">
//         <div className="flex-1 overflow-y-auto" style={{ height: "500px" }}>
//           <table className="min-w-full divide-y divide-gray-200 table-fixed">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase max-w-[200px]">
//                   Name
//                 </th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase max-w-[150px]">
//                   Serial Number
//                 </th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase max-w-[150px]">
//                   Inventory ID
//                 </th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase max-w-[120px]">
//                   Make
//                 </th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase max-w-[150px]">
//                   Client
//                 </th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase max-w-[150px]">
//                   Company Tag
//                 </th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase max-w-[120px]">
//                   Status
//                 </th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase max-w-[120px]">
//                   Tech Assigned
//                 </th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase max-w-[220px]">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {filteredComputers.map((computer) => (
//                 <tr key={computer.computerId} className="text-sm">
//                   <td className="px-4 py-3 max-w-[200px] truncate">
//                     {computer.name}
//                   </td>
//                   <td className="px-4 py-3 max-w-[150px] truncate">
//                     {computer.serialNumber}
//                   </td>
//                   <td className="px-4 py-3 max-w-[150px] truncate">
//                     {computer.inventoryTrackingNumber}
//                   </td>
//                   <td className="px-4 py-3 max-w-[120px] truncate">
//                     {computer.make}
//                   </td>
//                   <td className="px-4 py-3 max-w-[150px] truncate">
//                     {computer.client}
//                   </td>
//                   <td className="px-4 py-3 max-w-[150px] truncate">
//                     {computer.companyAssetTag}
//                   </td>
//                   <td className="px-4 py-3 max-w-[120px] truncate">
//                     {computer.repairDetails?.status ||
//                       (computer.isRepaired
//                         ? "Repaired"
//                         : computer.isFaulty
//                         ? "Faulty"
//                         : "Operational")}
//                   </td>
//                   <td className="px-4 py-3 max-w-[120px] truncate">
//                     {computer.repairDetails?.resourceassigned || "Unassigned"}
//                   </td>
//                   <td className="px-4 py-3 max-w-[220px] overflow-hidden whitespace-nowrap space-x-2">
//                     <button
//                       onClick={() => handleViewReport(computer.computerId)}
//                       className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 text-xs"
//                     >
//                       View
//                     </button>
//                     <button
//                       onClick={() => handleEditPost(computer.computerId)}
//                       className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 text-xs"
//                     >
//                       Edit
//                     </button>
//                     {!computer.isRepaired && (
//                       <button
//                         onClick={() => handleCloseComputer(computer.computerId)}
//                         className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600 text-xs"
//                       >
//                         Close
//                       </button>
//                     )}
//                     <button
//                       onClick={() => handleDeleteClick(computer.computerId)}
//                       className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600 text-xs"
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       <div className="md:hidden space-y-4 p-4">
//         {filteredComputers.map((computer) => (
//           <div
//             key={computer.computerId}
//             className="bg-white p-4 shadow rounded-lg"
//           >
//             <h3 className="text-lg font-bold truncate">{computer.name}</h3>
//             <p className="text-gray-500 text-sm">{computer.serialNumber}</p>
//             <div className="grid grid-cols-2 gap-4 text-sm text-gray-700 mt-2">
//               <p>
//                 <span className="font-semibold">Tracking No:</span>{" "}
//                 {computer.inventoryTrackingNumber}
//               </p>
//               <p>
//                 <span className="font-semibold">Make:</span> {computer.make}
//               </p>
//               <p>
//                 <span className="font-semibold">Client:</span> {computer.client}
//               </p>
//               <p>
//                 <span className="font-semibold">Asset Tag:</span>{" "}
//                 {computer.companyAssetTag}
//               </p>
//               <p className="col-span-2 text-gray-500">
//                 <span className="font-semibold">Status:</span>{" "}
//                 {computer.repairDetails?.status ||
//                   (computer.isRepaired
//                     ? "Repaired"
//                     : computer.isFaulty
//                     ? "Faulty"
//                     : "Operational")}
//               </p>
//               <p className="col-span-2 text-gray-500">
//                 <span className="font-semibold">Tech:</span>{" "}
//                 {computer.repairDetails?.resourceassigned || "Unassigned"}
//               </p>
//             </div>
//             <div className="mt-3 flex gap-2 flex-wrap">
//               <button
//                 onClick={() => handleViewReport(computer.computerId)}
//                 className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
//               >
//                 View
//               </button>
//               <button
//                 onClick={() => handleEditPost(computer.computerId)}
//                 className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
//               >
//                 Edit
//               </button>
//               {!computer.isRepaired && (
//                 <button
//                   onClick={() => handleCloseComputer(computer.computerId)}
//                   className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
//                 >
//                   Close
//                 </button>
//               )}
//               <button
//                 onClick={() => handleDeleteClick(computer.computerId)}
//                 className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//       {modalOpen && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md h-52 flex flex-col justify-between">
//             <div>
//               <h2 className="text-lg font-bold">Confirm Deletion</h2>
//               <p className="text-gray-600 mt-2">
//                 Are you sure you want to delete this computer?
//               </p>
//             </div>
//             <div className="mt-4 flex justify-end space-x-2">
//               <button
//                 onClick={handleDeletePost}
//                 className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 w-1/3"
//               >
//                 Delete
//               </button>
//               <button
//                 onClick={closeModal}
//                 className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 w-1/3"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {isModalOpen && (
//         <div>
//           <AddComputerForm
//             setIsModalOpen={setIsModalOpen}
//             onComputerAdded={handleComputerUpdated}
//           />
//         </div>
//       )}
//       {modalOpenEdit && (
//         <div>
//           <EditComputerForm
//             id={computerToEdit}
//             setIsModalOpen={setModalOpenEdit}
//             onComputerAdded={handleComputerUpdated}
//           />
//         </div>
//       )}

//       {modalOpenClose && (
//         <div>
//           <CloseComputerForm
//             computerId={computerToClose}
//             setIsModalOpen={setModalOpenClose}
//             handleComputerUpdated={handleComputerUpdated} // Pass refresh function
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// export default Inventory;

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../Context/api";
import Spinner from "../Helpers/Spinner";
import AddComputerForm from "./AddComputerForm";
import EditComputerForm from "./EditComputerForm";
import CloseComputerForm from "./CloseComputerForm";
import { useAuth } from "../Context/AuthContext";

function Inventory() {
  const [computers, setComputers] = useState([]);
  const [computerToDelete, setComputerToDelete] = useState(null);
  const [computerToEdit, setComputerToEdit] = useState(null);
  const [computerToClose, setComputerToClose] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenEdit, setModalOpenEdit] = useState(false);
  const [modalOpenClose, setModalOpenClose] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  // New state for filters
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === "Admin";

  const fetchComputers = async () => {
    try {
      const response = await API.get("/computers");
      const transformed = response.data.map((item) => {
        console.log("Current item:", item); // Log each item
        return {
          computerId: item.fields.ComputerID,
          name: item.fields.Name,
          client: item.fields.Client,
          model: item.fields.Model,
          serialNumber: item.fields.SerialNumber,
          inventoryTrackingNumber: item.fields.InventoryTrackingNumber,
          make: item.fields.Make,
          companyAssetTag: item.fields.CompanyAssetTag,
          isFaulty: item.fields.IsFaulty,
          isRepaired: item.fields.IsRepaired,
          createdBy: item.fields.CreatedBy,
          taskId: item.fields.TaskID,
          createdAt: item.createdAt, // From backend data
          updatedAt: item.updatedAt, // From backend data

          repairDetails: item.repairDetails
            ? {
                title: item.repairDetails.Title,
                repairDetails: item.repairDetails.RepairDetails,
                computerId: item.repairDetails.ComputerID,
                resourceAssigned: item.repairDetails.ResourceAssigned,
                status: item.repairDetails.Status,
                date: item.repairDetails.Date,
                recommendations: item.repairDetails.Recommendations,
                companyAssetTag: item.repairDetails.CompanyAssetTag,
                repairId: item.repairDetails.RepairID,
              }
            : null,
          repairHistory: item.repairHistory || [],
          changeHistory: item.changeHistory || [],
        };
      });
      setComputers(transformed);
      console.log(transformed);
      console.log(response.data);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch computers");
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchComputers();
  }, []);

  const handleDeleteClick = (computerId) => {
    setComputerToDelete(computerId);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalOpenEdit(false);
    setModalOpenClose(false);
    setComputerToDelete(null);
    setComputerToEdit(null);
    setComputerToClose(null);
  };

  const handleDeletePost = async () => {
    if (computerToDelete) {
      setIsDeleting(true);
      try {
        const computer = computers.find(
          (computer) => computer.computerId === computerToDelete
        );
        const taskId = computer.taskId;
        if (taskId && computerToDelete) {
          await API.delete(`/tasks/${taskId}`);
        }
        await API.delete(`/computers/${computerToDelete}`);
        setComputers(
          computers.filter(
            (computer) => computer.computerId !== computerToDelete
          )
        );
      } catch (error) {
        alert("Failed to delete computer and task.");
      } finally {
        setIsDeleting(false);
        closeModal();
      }
    }
  };

  const handleEditPost = (computerId) => {
    setComputerToEdit(computerId);
    setModalOpenEdit(true);
  };

  const handleCloseComputer = (computerId) => {
    setComputerToClose(computerId);
    setModalOpenClose(true);
  };

  const handleViewReport = (computerId) => {
    navigate(`/report/${computerId}`);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // New filter functions
  const handleCategoryChange = (e) => {
    setCategoryFilter(e.target.value);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const filteredComputers = computers.filter((computer) => {
    // Search filter
    const matchesSearch =
      (computer.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (computer.serialNumber || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

    // Category filter
    let matchesCategory = true;
    if (categoryFilter !== "All") {
      if (categoryFilter === "Repaired") {
        matchesCategory = computer.isRepaired;
      } else if (categoryFilter === "Faulty") {
        matchesCategory = computer.isFaulty && !computer.isRepaired;
      } else if (categoryFilter === "Operational") {
        matchesCategory = !computer.isFaulty && !computer.isRepaired;
      }
    }

    // Date filter
    let matchesDate = true;
    if (startDate || endDate) {
      const computerDate = new Date(computer.createdAt || computer.updatedAt);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;
      if (start && computerDate < start) matchesDate = false;
      if (end && computerDate > end) matchesDate = false;
    }

    return matchesSearch && matchesCategory && matchesDate;
  });

  // Export to CSV
  const exportToCSV = () => {
    const headers = [
      "ComputerID",
      "Name",
      "Client",
      "Model",
      "SerialNumber",
      "InventoryTrackingNumber",
      "Make",
      "CompanyAssetTag",
      "Status",
      "TechAssigned",
      "CreatedAt",
      "UpdatedAt",
    ];
    const rows = filteredComputers.map((computer) => [
      computer.computerId,
      computer.name,
      computer.client,
      computer.model,
      computer.serialNumber,
      computer.inventoryTrackingNumber,
      computer.make,
      computer.companyAssetTag,
      computer.repairDetails?.status ||
        (computer.isRepaired
          ? "Repaired"
          : computer.isFaulty
          ? "Faulty"
          : "Operational"),
      computer.repairDetails?.resourceAssigned || "Unassigned",
      computer.createdAt,
      computer.updatedAt,
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "computers_export.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAddComputer = () => {
    setIsModalOpen(true);
  };

  const handleComputerUpdated = () => {
    fetchComputers();
    closeModal();
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-red-500 text-lg">{error}</div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      {/* Static Header */}
      <h3 className="text-xl font-semibold mb-2 text-gray-900">Inventory</h3>

      {/* Data Filter & Export Section */}
      <div className="py-2 mb-4 flex flex-col sm:flex-row items-center justify-between gap-4 flex-wrap">
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <div>
            <label className="text-sm font-medium text-gray-700 mr-2">
              Search:
            </label>
            <input
              type="text"
              placeholder="Search by name or serial number..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full sm:w-80 p-2.5 bg-white border border-gray-300 rounded-md text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent transition-all duration-200"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 mr-2">
              Category:
            </label>
            <select
              value={categoryFilter}
              onChange={handleCategoryChange}
              className="p-2.5 bg-white border border-gray-300 rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent transition-all duration-200"
            >
              <option value="All">All Categories</option>
              <option value="Repaired">Repaired</option>
              <option value="Faulty">Faulty</option>
              <option value="Operational">Operational</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 mr-2">
              Start Date:
            </label>
            <input
              type="date"
              value={startDate}
              onChange={handleStartDateChange}
              className="p-2.5 bg-white border border-gray-300 rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent transition-all duration-200"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 mr-2">
              End Date:
            </label>
            <input
              type="date"
              value={endDate}
              onChange={handleEndDateChange}
              className="p-2.5 bg-white border border-gray-300 rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent transition-all duration-200"
            />
          </div>
        </div>
        <div className="flex gap-4">
          <button
            onClick={handleAddComputer}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm"
          >
            Add Computer
          </button>
          <button
            onClick={exportToCSV}
            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 text-sm font-medium transition-all duration-200 shadow-sm"
          >
            Export to CSV
          </button>
        </div>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto space-y-3">
        <div className="hidden sm:block bg-white rounded-lg shadow-sm">
          <table className="w-full text-left table-fixed">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Name
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Serial Number
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Inventory ID
                </th>
                <th className="w-[10%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Make
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Client
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Company Tag
                </th>
                <th className="w-[10%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Status
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Tech Assigned
                </th>
                <th className="w-[18%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider min-w-[220px]">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-300">
              {filteredComputers.map((computer, index) => (
                <tr
                  key={computer.computerId}
                  className={`text-sm ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-gray-100 transition-colors duration-150`}
                >
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    <span
                      onClick={() => handleViewReport(computer.computerId)}
                      className="hover:underline cursor-pointer"
                    >
                      {computer.name}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {computer.serialNumber}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {computer.inventoryTrackingNumber}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {computer.make}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {computer.client}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {computer.companyAssetTag}
                  </td>
                  <td className="px-4 py-3 text-gray-600 text-sm whitespace-normal break-words align-top">
                    {computer.repairDetails?.status ||
                      (computer.isRepaired
                        ? "Repaired"
                        : computer.isFaulty
                        ? "Faulty"
                        : "Operational")}
                  </td>
                  <td className="px-4 py-3 text-gray-600 text-sm whitespace-normal break-words align-top">
                    {computer.repairDetails?.resourceAssigned || "Unassigned"}
                  </td>
                  <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
                    <button
                      onClick={() => handleEditPost(computer.computerId)}
                      className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                    >
                      Edit
                    </button>
                    {!computer.isRepaired && (
                      <button
                        onClick={() => handleCloseComputer(computer.computerId)}
                        className="bg-emerald-500 text-white w-20 px-3 py-1 rounded-md hover:bg-emerald-600 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-opacity-50 transition-all duration-200"
                      >
                        Close
                      </button>
                    )}
                    {isAdmin && (
                      <button
                        onClick={() => handleDeleteClick(computer.computerId)}
                        className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Cards for Small Screens */}
        <div className="sm:hidden space-y-4">
          {filteredComputers.map((computer) => (
            <div
              key={computer.computerId || computer.serialNumber}
              className="bg-white rounded-lg shadow-sm p-4 flex flex-col gap-3 hover:shadow-md transition-shadow duration-200"
            >
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-700">
                    Name
                  </span>
                  <span className="text-sm text-gray-600 break-words">
                    <span
                      onClick={() => handleViewReport(computer.computerId)}
                      className="hover:underline cursor-pointer"
                    >
                      {computer.name}
                    </span>
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-700">
                    Serial Number
                  </span>
                  <span className="text-sm text-gray-600 break-words">
                    {computer.serialNumber}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-700">
                    Tracking No:
                  </span>
                  <span className="text-sm text-gray-600 break-words">
                    {computer.inventoryTrackingNumber}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-700">
                    Make
                  </span>
                  <span className="text-sm text-gray-600 break-words">
                    {computer.make}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-700">
                    Client
                  </span>
                  <span className="text-sm text-gray-600 break-words">
                    {computer.client}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-700">
                    Company Tag
                  </span>
                  <span className="text-sm text-gray-600 break-words">
                    {computer.companyAssetTag}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-700">
                    Status
                  </span>
                  <span className="text-sm text-gray-600 break-words">
                    {computer.repairDetails?.status ||
                      (computer.isRepaired
                        ? "Repaired"
                        : computer.isFaulty
                        ? "Faulty"
                        : "Operational")}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-sm font-semibold text-gray-700">
                    Tech Assigned
                  </span>
                  <span className="text-sm text-gray-600 break-words">
                    {computer.repairDetails?.resourceAssigned || "Unassigned"}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-2 justify-start">
                <button
                  onClick={() => handleEditPost(computer.computerId)}
                  className="flex-1 px-2 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium transition-all duration-200 shadow-sm"
                >
                  Edit
                </button>
                {!computer.isRepaired && (
                  <button
                    onClick={() => handleCloseComputer(computer.computerId)}
                    className="flex-1 px-2 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 text-sm font-medium transition-all duration-200 shadow-sm"
                  >
                    Close
                  </button>
                )}
                {isAdmin && (
                  <button
                    onClick={() => handleDeleteClick(computer.computerId)}
                    className="px-3 py-2 bg-rose-600 text-white rounded-md hover:bg-rose-700 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal for Delete Confirmation */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-[90vw] sm:max-w-md shadow-xl">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">
              Confirm Deletion
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
              Are you sure you want to delete this computer? This action cannot
              be undone.
            </p>
            <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
              <button
                onClick={closeModal}
                className="px-4 py-2 text-sm sm:text-base text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors duration-200 w-full sm:w-auto"
              >
                Cancel
              </button>
              <button
                onClick={handleDeletePost}
                disabled={isDeleting}
                className={`px-4 py-2 text-sm sm:text-base text-white rounded-lg transition-all duration-200 ${
                  isDeleting
                    ? "bg-red-300 cursor-not-allowed"
                    : "bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                }`}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <AddComputerForm
          setIsModalOpen={setIsModalOpen}
          onComputerAdded={handleComputerUpdated}
        />
      )}
      {modalOpenEdit && (
        <EditComputerForm
          id={computerToEdit}
          setIsModalOpen={setModalOpenEdit}
          onComputerAdded={handleComputerUpdated}
        />
      )}
      {modalOpenClose && (
        <CloseComputerForm
          computerId={computerToClose}
          setIsModalOpen={setModalOpenClose}
          handleComputerUpdated={handleComputerUpdated}
        />
      )}
    </div>
  );
}

export default Inventory;

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import API from "../Context/api";
// import Spinner from "../Helpers/Spinner";
// import AddComputerForm from "./AddComputerForm";
// import EditComputerForm from "./EditComputerForm";
// import CloseComputerForm from "./CloseComputerForm";
// import { useAuth } from "../Context/AuthContext";

// function Inventory() {
//   const [computers, setComputers] = useState([]);
//   const [computerToDelete, setComputerToDelete] = useState(null);
//   const [computerToEdit, setComputerToEdit] = useState(null);
//   const [computerToClose, setComputerToClose] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalOpenEdit, setModalOpenEdit] = useState(false);
//   const [modalOpenClose, setModalOpenClose] = useState(false);
//   const [isDeleting, setIsDeleting] = useState(false);

//   const navigate = useNavigate();

//   const { user } = useAuth();
//   const isAdmin = user?.role === "Admin";

//   // const fetchComputers = async () => {
//   //   try {
//   //     const response = await API.get("/computers");
//   //     setComputers(response.data);
//   //     console.log("response.data................");
//   //     console.log(response.data);
//   //     setLoading(false);
//   //   } catch (error) {
//   //     setError("Failed to fetch computers");
//   //     setLoading(false);
//   //   }
//   // };

//   const fetchComputers = async () => {
//     try {
//       const response = await API.get("/computers");
//       // response.data is an array of { fields: {...}, repairDetails: {...}, ... }

//       // Flatten each computer to the UI-friendly shape
//       const transformed = response.data.map((item) => {
//         return {
//           // flatten computer fields
//           computerId: item.fields.ComputerID,
//           name: item.fields.Name,
//           client: item.fields.Client,
//           model: item.fields.Model,
//           serialNumber: item.fields.SerialNumber,
//           inventoryTrackingNumber: item.fields.InventoryTrackingNumber,
//           make: item.fields.Make,
//           companyAssetTag: item.fields.CompanyAssetTag,
//           isFaulty: item.fields.IsFaulty,
//           isRepaired: item.fields.IsRepaired,
//           createdBy: item.fields.CreatedBy,
//           taskId: item.fields.TaskID,

//           // flatten repairDetails or null
//           repairDetails: item.repairDetails
//             ? {
//                 title: item.repairDetails.Title,
//                 repairDetails: item.repairDetails.RepairDetails,
//                 computerId: item.repairDetails.ComputerID,
//                 resourceAssigned: item.repairDetails.ResourceAssigned,
//                 status: item.repairDetails.Status,
//                 date: item.repairDetails.Date,
//                 recommendations: item.repairDetails.Recommendations,
//                 companyAssetTag: item.repairDetails.CompanyAssetTag,
//                 repairId: item.repairDetails.RepairID,
//               }
//             : null,

//           // repairHistory and changeHistory can stay as is or flattened similarly if needed
//           repairHistory: item.repairHistory || [],
//           changeHistory: item.changeHistory || [],
//         };
//       });

//       setComputers(transformed);

//       console.log(transformed);
//       console.log(response.data);

//       setLoading(false);
//     } catch (error) {
//       setError("Failed to fetch computers");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchComputers();
//   }, []);

//   // const getTechnicianIdByName = (name) => {
//   //   const tech = technicians.find((t) => t.name === name);
//   //   return tech ? tech.userId : null;
//   // };

//   const handleDeleteClick = (computerId) => {
//     setComputerToDelete(computerId);
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setModalOpenEdit(false);
//     setModalOpenClose(false);
//     setComputerToDelete(null);
//     setComputerToEdit(null);
//     setComputerToClose(null);
//   };

//   // const handleDeletePost = async () => {
//   //   if (computerToDelete) {
//   //     try {
//   //       await API.delete(`/computers/${computerToDelete}`);
//   //       setComputers(
//   //         computers.filter(
//   //           (computer) => computer.computerId !== computerToDelete
//   //         )
//   //       );
//   //     } catch (error) {
//   //       alert("Failed to delete computer.");
//   //     } finally {
//   //       closeModal();
//   //     }
//   //   }
//   // };

//   const handleDeletePost = async () => {
//     if (computerToDelete) {
//       setIsDeleting(true); // Set deletion in progress
//       try {
//         // Get the task ID associated with the computer
//         const computer = computers.find(
//           (computer) => computer.computerId === computerToDelete
//         );
//         const taskId = computer.taskId;

//         // Delete the task
//         if (taskId && computerToDelete) {
//           // await API.delete(`/tasks/${computerToDelete}/${taskId}`);
//           await API.delete(`/tasks/${taskId}`);
//         }

//         // Delete the computer
//         await API.delete(`/computers/${computerToDelete}`);
//         setComputers(
//           computers.filter(
//             (computer) => computer.computerId !== computerToDelete
//           )
//         );
//       } catch (error) {
//         alert("Failed to delete computer and task.");
//       } finally {
//         setIsDeleting(false); // Reset deletion state
//         closeModal();
//       }
//     }
//   };

//   const handleEditPost = (computerId) => {
//     setComputerToEdit(computerId);
//     setModalOpenEdit(true);
//   };

//   const handleCloseComputer = (computerId) => {
//     setComputerToClose(computerId);
//     setModalOpenClose(true);
//   };

//   const handleViewReport = (computerId) => {
//     navigate(`/report/${computerId}`);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const filteredComputers = computers.filter(
//     (computer) =>
//       (computer.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (computer.serialNumber || "")
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase())
//   );

//   const handleAddComputer = () => {
//     setIsModalOpen(true);
//   };

//   const handleComputerUpdated = () => {
//     fetchComputers();
//     closeModal();
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-full">
//         <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-full">
//         <div className="text-red-500 text-lg">{error}</div>
//       </div>
//     );
//   }

//   return (
//     // <div className="p-4 bg-gray-50 min-h-full flex flex-col">
//     //   {/* Sticky Search Bar */}
//     //   <div className="bg-white rounded-lg shadow-sm p-4 sticky top-0 z-10">
//     //     <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
//     //       <input
//     //         type="text"
//     //         placeholder="Search by name or serial number..."
//     //         value={searchQuery}
//     //         onChange={handleSearchChange}
//     //         className="w-full sm:w-80 p-2.5 bg-gray-100 border border-gray-200 rounded-md text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
//     //       />
//     //       <button
//     //         onClick={handleAddComputer}
//     //         className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
//     //       >
//     //         Add Computer
//     //       </button>
//     //     </div>
//     //   </div>

//     //   {/* Scrollable Content */}
//     //   <div className="flex-1 overflow-y-auto mt-4">
//     //     {/* Table for Larger Screens */}
//     //     {/* Table for Larger Screens */}
//     //     <div className="hidden sm:block bg-white rounded-lg shadow-sm">
//     //       <table className="w-full text-left table-fixed">
//     //         <thead className="bg-gray-100 sticky top-0 z-10">
//     //           <tr>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Name
//     //             </th>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Serial Number
//     //             </th>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Inventory ID
//     //             </th>
//     //             <th className="w-[10%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Make
//     //             </th>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Client
//     //             </th>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Company Tag
//     //             </th>
//     //             <th className="w-[10%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Status
//     //             </th>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Tech Assigned
//     //             </th>
//     //             <th className="w-[18%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider min-w-[220px]">
//     //               Actions
//     //             </th>
//     //           </tr>
//     //         </thead>
//     //         <tbody className="divide-y divide-gray-100">
//     //           {filteredComputers.map((computer) => (
//     //             <tr
//     //               key={computer.computerId}
//     //               className="hover:bg-gray-50 transition-colors duration-150"
//     //             >
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {computer.name}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {computer.serialNumber}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {computer.inventoryTrackingNumber}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {computer.make}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {computer.client}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {computer.companyAssetTag}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {computer.repairDetails?.status ||
//     //                   (computer.isRepaired
//     //                     ? "Repaired"
//     //                     : computer.isFaulty
//     //                     ? "Faulty"
//     //                     : "Operational")}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {computer.repairDetails?.resourceassigned || "Unassigned"}
//     //               </td>
//     //               <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
//     //                 <button
//     //                   onClick={() => handleViewReport(computer.computerId)}
//     //                   className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
//     //                 >
//     //                   View
//     //                 </button>
//     //                 <button
//     //                   onClick={() => handleEditPost(computer.computerId)}
//     //                   className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
//     //                 >
//     //                   Edit
//     //                 </button>

//     //                 {!computer.isRepaired && (
//     //                   <button
//     //                     onClick={() => handleCloseComputer(computer.computerId)}
//     //                     className="px-3 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
//     //                   >
//     //                     Close
//     //                   </button>
//     //                 )}

//     //                 {isAdmin && (
//     //                   <button
//     //                     onClick={() => handleDeleteClick(computer.computerId)}
//     //                     className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
//     //                   >
//     //                     Delete
//     //                   </button>
//     //                 )}
//     //               </td>
//     //             </tr>
//     //           ))}
//     //         </tbody>
//     //       </table>
//     //     </div>

//     //     {/* Cards for Small Screens */}
//     //     <div className="sm:hidden space-y-4">
//     //       {filteredComputers.map((computer) => (
//     //         <div
//     //           key={computer.computerId || computer.serialNumber}
//     //           className="bg-white rounded-lg shadow-sm p-4 flex flex-col gap-3 hover:shadow-md transition-shadow duration-200"
//     //         >
//     //           <div className="flex flex-col gap-2">
//     //             <div className="flex justify-between items-start">
//     //               <span className="text-sm font-semibold text-gray-600">
//     //                 Name
//     //               </span>
//     //               <span className="text-sm text-gray-700 break-words">
//     //                 {computer.name}
//     //               </span>
//     //             </div>
//     //             <div className="flex justify-between items-start">
//     //               <span className="text-sm font-semibold text-gray-600">
//     //                 Serial Number
//     //               </span>
//     //               <span className="text-sm text-gray-700 break-words">
//     //                 {computer.serialNumber}
//     //               </span>
//     //             </div>
//     //             <div className="flex justify-between items-start">
//     //               <span className="text-sm font-semibold text-gray-600">
//     //                 Tracking No:
//     //               </span>
//     //               <span className="text-sm text-gray-700 break-words">
//     //                 {computer.inventoryTrackingNumber}
//     //               </span>
//     //             </div>
//     //             <div className="flex justify-between items-start">
//     //               <span className="text-sm font-semibold text-gray-600">
//     //                 Make
//     //               </span>
//     //               <span className="text-sm text-gray-700 break-words">
//     //                 {computer.make}
//     //               </span>
//     //             </div>
//     //             <div className="flex justify-between items-start">
//     //               <span className="text-sm font-semibold text-gray-600">
//     //                 Client
//     //               </span>
//     //               <span className="text-sm text-gray-700 break-words">
//     //                 {computer.client}
//     //               </span>
//     //             </div>
//     //             <div className="flex justify-between items-start">
//     //               <span className="text-sm font-semibold text-gray-600">
//     //                 Company Tag
//     //               </span>
//     //               <span className="text-sm text-gray-700 break-words">
//     //                 {computer.companyAssetTag}
//     //               </span>
//     //             </div>
//     //             <div className="flex justify-between items-start">
//     //               <span className="text-sm font-semibold text-gray-600">
//     //                 Status
//     //               </span>
//     //               <span className="text-sm text-gray-700 break-words">
//     //                 {computer.repairDetails?.status ||
//     //                   (computer.isRepaired
//     //                     ? "Repaired"
//     //                     : computer.isFaulty
//     //                     ? "Faulty"
//     //                     : "Operational")}
//     //               </span>
//     //             </div>
//     //             <div className="flex justify-between items-start">
//     //               <span className="text-sm font-semibold text-gray-600">
//     //                 Tech Assigned
//     //               </span>
//     //               <span className="text-sm text-gray-700 break-words">
//     //                 {computer.repairDetails?.resourceassigned || "Unassigned"}
//     //               </span>
//     //             </div>
//     //           </div>
//     //           <div className="flex flex-col gap-2 justify-start">
//     //             <button
//     //               onClick={() => handleViewReport(computer.computerId)}
//     //               className="flex-1 px-2 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm"
//     //             >
//     //               View
//     //             </button>
//     //             <button
//     //               onClick={() => handleEditPost(computer.computerId)}
//     //               className="flex-1 px-2 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm"
//     //             >
//     //               Edit
//     //             </button>
//     //             {!computer.isRepaired && (
//     //               <button
//     //                 onClick={() => handleCloseComputer(computer.computerId)}
//     //                 className="flex-1 px-2 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 text-sm font-medium transition-all duration-200 shadow-sm"
//     //               >
//     //                 Close
//     //               </button>
//     //             )}
//     //             {isAdmin && (
//     //               <button
//     //                 onClick={() => handleDeleteClick(computer.computerId)}
//     //                 className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
//     //               >
//     //                 Delete
//     //               </button>
//     //             )}
//     //           </div>
//     //         </div>
//     //       ))}
//     //     </div>
//     //   </div>

//     //   {/* Modal for Delete Confirmation */}
//     //   {modalOpen && (
//     //     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//     //       <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-[90vw] sm:max-w-md shadow-xl">
//     //         <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-3 sm:mb-4">
//     //           Confirm Deletion
//     //         </h3>
//     //         <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
//     //           Are you sure you want to delete this computer? This action cannot
//     //           be undone.
//     //         </p>
//     //         <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
//     //           <button
//     //             onClick={closeModal}
//     //             className="px-4 py-2 text-sm sm:text-base text-gray-600 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors duration-200 w-full sm:w-auto"
//     //           >
//     //             Cancel
//     //           </button>
//     //           <button
//     //             onClick={handleDeletePost}
//     //             className="px-4 py-2 text-sm sm:text-base text-white bg-red-500 hover:bg-red-600 rounded-md transition-colors duration-200 w-full sm:w-auto"
//     //           >
//     //             Delete
//     //           </button>
//     //         </div>
//     //       </div>
//     //     </div>
//     //   )}

//     //   {isModalOpen && (
//     //     <AddComputerForm
//     //       setIsModalOpen={setIsModalOpen}
//     //       onComputerAdded={handleComputerUpdated}
//     //     />
//     //   )}
//     //   {modalOpenEdit && (
//     //     <EditComputerForm
//     //       id={computerToEdit}
//     //       setIsModalOpen={setModalOpenEdit}
//     //       onComputerAdded={handleComputerUpdated}
//     //     />
//     //   )}
//     //   {modalOpenClose && (
//     //     <CloseComputerForm
//     //       computerId={computerToClose}
//     //       setIsModalOpen={setModalOpenClose}
//     //       handleComputerUpdated={handleComputerUpdated}
//     //     />
//     //   )}
//     // </div>

//     <div className="h-full flex flex-col">
//       {/* Static Header */}
//       {/* Static Header */}
//       <h3 className="text-xl font-semibold mb-2 text-gray-900">Inventory</h3>

//       <div className="py-2 mb-4 flex items-center justify-between gap-4 flex-wrap">
//         <input
//           type="text"
//           placeholder="Search by name or serial number..."
//           value={searchQuery}
//           onChange={handleSearchChange}
//           className="w-full sm:w-80 p-2.5 bg-white border border-gray-300 rounded-md text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent transition-all duration-200"
//         />
//         <button
//           onClick={handleAddComputer}
//           className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
//         >
//           Add Computer
//         </button>
//       </div>

//       {/* Scrollable Content */}
//       <div className="flex-1 overflow-y-auto space-y-3">
//         <div className="hidden sm:block bg-white rounded-lg shadow-sm">
//           <table className="w-full text-left table-fixed">
//             <thead className="bg-gray-100 sticky top-0 z-10">
//               <tr>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Name
//                 </th>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Serial Number
//                 </th>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Inventory ID
//                 </th>
//                 <th className="w-[10%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Make
//                 </th>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Client
//                 </th>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Company Tag
//                 </th>
//                 <th className="w-[10%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Status
//                 </th>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Tech Assigned
//                 </th>
//                 <th className="w-[18%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider min-w-[220px]">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-300">
//               {filteredComputers.map((computer, index) => (
//                 <tr
//                   key={computer.computerId}
//                   className={`text-sm ${
//                     index % 2 === 0 ? "bg-white" : "bg-gray-50"
//                   } hover:bg-gray-100 transition-colors duration-150`}
//                 >
//                   <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//                     <span
//                       onClick={() => handleViewReport(computer.computerId)}
//                       className="hover:underline cursor-pointer"
//                     >
//                       {computer.name}
//                     </span>
//                   </td>
//                   <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//                     {computer.serialNumber}
//                   </td>
//                   <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//                     {computer.inventoryTrackingNumber}
//                   </td>
//                   <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//                     {computer.make}
//                   </td>
//                   <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//                     {computer.client}
//                   </td>
//                   <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//                     {computer.companyAssetTag}
//                   </td>
//                   <td className="px-4 py-3 text-gray-600 text-sm whitespace-normal break-words align-top">
//                     {computer.repairDetails?.status ||
//                       (computer.isRepaired
//                         ? "Repaired"
//                         : computer.isFaulty
//                         ? "Faulty"
//                         : "Operational")}
//                   </td>
//                   <td className="px-4 py-3 text-gray-600 text-sm whitespace-normal break-words align-top">
//                     {computer.repairDetails?.resourceAssigned || "Unassigned"}
//                   </td>
//                   <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
//                     {/* <button
//                       onClick={() => handleViewReport(computer.computerId)}
//                       className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
//                     >
//                       View
//                     </button> */}
//                     <button
//                       onClick={() => handleEditPost(computer.computerId)}
//                       className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
//                     >
//                       Edit
//                     </button>
//                     {!computer.isRepaired && (
//                       <button
//                         onClick={() => handleCloseComputer(computer.computerId)}
//                         className="bg-emerald-500 text-white w-20 px-3 py-1 rounded-md hover:bg-emerald-600 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-opacity-50 transition-all duration-200"
//                       >
//                         Close
//                       </button>
//                     )}
//                     {isAdmin && (
//                       <button
//                         onClick={() => handleDeleteClick(computer.computerId)}
//                         className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
//                       >
//                         Delete
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Cards for Small Screens */}
//         <div className="sm:hidden space-y-4">
//           {filteredComputers.map((computer) => (
//             <div
//               key={computer.computerId || computer.serialNumber}
//               className="bg-white rounded-lg shadow-sm p-4 flex flex-col gap-3 hover:shadow-md transition-shadow duration-200"
//             >
//               <div className="flex flex-col gap-2">
//                 <div className="flex justify-between items-start">
//                   <span className="text-sm font-semibold text-gray-700">
//                     Name
//                   </span>
//                   <span className="text-sm text-gray-600 break-words">
//                     <span
//                       onClick={() => handleViewReport(computer.computerId)}
//                       className="hover:underline cursor-pointer"
//                     >
//                       {computer.name}
//                     </span>
//                   </span>
//                 </div>
//                 <div className="flex justify-between items-start">
//                   <span className="text-sm font-semibold text-gray-700">
//                     Serial Number
//                   </span>
//                   <span className="text-sm text-gray-600 break-words">
//                     {computer.serialNumber}
//                   </span>
//                 </div>
//                 <div className="flex justify-between items-start">
//                   <span className="text-sm font-semibold text-gray-700">
//                     Tracking No:
//                   </span>
//                   <span className="text-sm text-gray-600 break-words">
//                     {computer.inventoryTrackingNumber}
//                   </span>
//                 </div>
//                 <div className="flex justify-between items-start">
//                   <span className="text-sm font-semibold text-gray-700">
//                     Make
//                   </span>
//                   <span className="text-sm text-gray-600 break-words">
//                     {computer.make}
//                   </span>
//                 </div>
//                 <div className="flex justify-between items-start">
//                   <span className="text-sm font-semibold text-gray-700">
//                     Client
//                   </span>
//                   <span className="text-sm text-gray-600 break-words">
//                     {computer.client}
//                   </span>
//                 </div>
//                 <div className="flex justify-between items-start">
//                   <span className="text-sm font-semibold text-gray-700">
//                     Company Tag
//                   </span>
//                   <span className="text-sm text-gray-600 break-words">
//                     {computer.companyAssetTag}
//                   </span>
//                 </div>
//                 <div className="flex justify-between items-start">
//                   <span className="text-sm font-semibold text-gray-700">
//                     Status
//                   </span>
//                   <span className="text-sm text-gray-600 break-words">
//                     {computer.repairDetails?.status ||
//                       (computer.isRepaired
//                         ? "Repaired"
//                         : computer.isFaulty
//                         ? "Faulty"
//                         : "Operational")}
//                   </span>
//                 </div>
//                 <div className="flex justify-between items-start">
//                   <span className="text-sm font-semibold text-gray-700">
//                     Tech Assigned
//                   </span>
//                   <span className="text-sm text-gray-600 break-words">
//                     {computer.repairDetails?.resourceAssigned || "Unassigned"}
//                   </span>
//                 </div>
//               </div>
//               <div className="flex flex-col gap-2 justify-start">
//                 {/* <button
//                   onClick={() => handleViewReport(computer.computerId)}
//                   className="flex-1 px-2 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium transition-all duration-200 shadow-sm"
//                 >
//                   View
//                 </button> */}
//                 <button
//                   onClick={() => handleEditPost(computer.computerId)}
//                   className="flex-1 px-2 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium transition-all duration-200 shadow-sm"
//                 >
//                   Edit
//                 </button>
//                 {!computer.isRepaired && (
//                   <button
//                     onClick={() => handleCloseComputer(computer.computerId)}
//                     className="flex-1 px-2 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 text-sm font-medium transition-all duration-200 shadow-sm"
//                   >
//                     Close
//                   </button>
//                 )}
//                 {isAdmin && (
//                   <button
//                     onClick={() => handleDeleteClick(computer.computerId)}
//                     className="px-3 py-2 bg-rose-600 text-white rounded-md hover:bg-rose-700 text-xs font-medium transition-all duration-200 shadow-sm min-w-[60px]"
//                   >
//                     Delete
//                   </button>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Modal for Delete Confirmation */}
//       {modalOpen && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-[90vw] sm:max-w-md shadow-xl">
//             <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">
//               Confirm Deletion
//             </h3>
//             <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
//               Are you sure you want to delete this computer? This action cannot
//               be undone.
//             </p>
//             <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
//               <button
//                 onClick={closeModal}
//                 className="px-4 py-2 text-sm sm:text-base text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors duration-200 w-full sm:w-auto"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDeletePost}
//                 disabled={isDeleting}
//                 className={`px-4 py-2 text-sm sm:text-base text-white rounded-lg transition-all duration-200 ${
//                   isDeleting
//                     ? "bg-red-300 dark:bg-red-400 cursor-not-allowed"
//                     : "bg-red-600 dark:bg-red-700 hover:bg-red-700 dark:hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
//                 }`}
//               >
//                 {isDeleting ? "Deleting..." : "Delete"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {isModalOpen && (
//         <AddComputerForm
//           setIsModalOpen={setIsModalOpen}
//           onComputerAdded={handleComputerUpdated}
//         />
//       )}
//       {modalOpenEdit && (
//         <EditComputerForm
//           id={computerToEdit}
//           setIsModalOpen={setModalOpenEdit}
//           onComputerAdded={handleComputerUpdated}
//         />
//       )}
//       {modalOpenClose && (
//         <CloseComputerForm
//           computerId={computerToClose}
//           setIsModalOpen={setModalOpenClose}
//           handleComputerUpdated={handleComputerUpdated}
//         />
//       )}
//     </div>
//   );
// }

// export default Inventory;
